import type { FC } from 'react';
import { Box, IconFilter, Text } from 'braid-design-system';

import { IconWithText } from 'src/components/common/IconTextLink';
import { useIconLabel } from 'src/components/common/IconTextLink/hooks/useIconLabel';
import * as styles from './FilterAction.css';

interface FilterActionProps {
  openFilterDrawer: () => void;
}

export const FilterAction: FC<FilterActionProps> = ({ openFilterDrawer }) => {
  const { getLabel } = useIconLabel();
  const filtersLabel = getLabel('Filters');
  return (
    <Box className={[styles.hideOnTablet]}>
      <Box cursor="pointer" onClick={() => openFilterDrawer()}>
        <Text baseline={false} weight="medium">
          <IconWithText icon={<IconFilter />} label={filtersLabel} />
        </Text>
      </Box>
    </Box>
  );
};
